export { BagLoyaltySubtitle } from './BagLoyaltySubtitle';
